import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PageTitle from "../XoSoCompound/PageTitle";
import DateFilter from "./DateFilter";
import ResultCard from "./ResultCard";
import useDienToan123 from "./useDienToan123";
import { TITLE, TZ, drawDateKey } from "./constants";
import "../XoSoCompound/XoSoCompound.css";
import "./DienToan123.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function DienToan123({ title, showTitle = false, defaultDate, dataDefault, config }) {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(defaultDate || dataDefault || config?.date || null);
  const { results, loading, resolvedDate } = useDienToan123(date);
  const selectedDate = date || resolvedDate || today;
  const hasSelected = results.some((item) => drawDateKey(item.drawDate) === selectedDate);

  return (
    <div className="xoso-compound dientoan123">
      {showTitle ? <PageTitle>{title || TITLE}</PageTitle> : null}

      <DateFilter value={selectedDate} onChange={setDate} maxDate={today} />

      <div className={`dt123-stack${loading ? " is-loading" : ""}`}>
        {loading ? <div className="dt123-stack__spinner" /> : null}
        {!loading && !hasSelected ? (
          <div className="dt123-card">
            <div className="xoso-kqxs__empty">
              Không có dữ liệu ngày {dayjs(selectedDate).format("DD/MM/YYYY")}
            </div>
          </div>
        ) : null}
        {results.map((item) => (
          <ResultCard key={item.id || item.drawDate} result={item} />
        ))}
      </div>
    </div>
  );
}

DienToan123.PageTitle = PageTitle;
DienToan123.DateFilter = DateFilter;
DienToan123.ResultCard = ResultCard;

export { PageTitle, DateFilter, ResultCard };
export default DienToan123;
